import { render, staticRenderFns } from "./slot-page.vue?vue&type=template&id=603dbd43&scoped=true"
import script from "./slot-page.vue?vue&type=script&lang=js"
export * from "./slot-page.vue?vue&type=script&lang=js"
import style0 from "./slot-page.vue?vue&type=style&index=0&id=603dbd43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603dbd43",
  null
  
)

export default component.exports